import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SignInComponent from './SignInComponent';
import SignUpComponent from './SignUpComponent';
import SocialAccount from './SocialAccountComponent';
import SignInWithOTP from './SignInWithOTPComponent';
import OldPassword from './OldPasswordComponent';
import SetPassword from './SetPassword';
import SignUpSocial from './SignUpSocial';
import SignInSocial from './SignInSocial';
import Loader from '../../components/common/Loader';
import { readCookie, eraseCookie } from '../../utils/Cookie';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import properties from "../../modules/ajio-util/properties";
import screen from '../../utils/pageType';
import { Feature, Variant } from '../../refresh/organism/ABFeature';

const pageTypeObject = Object.freeze({
  login: screen.login_signup,
  'login/password': screen.login_password,
  'login/otp': screen.login_otp,
  'login/password-set': { pageType: 'user account screen', pageName: 'password reset screen' },
  signup: screen.signup
});
class AuthModalDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backClicked: false
    };
    this.updateState = this._updateState.bind(this);
  }

  _updateState(newStateValue) {
    let newState = { ...this.state, ...newStateValue };
    this.setState(newState);
  }

  componentWillUnmount() {
    this.setState({
      backClicked: false
    });
  }

  componentToRender = (destSrc, viewType, userCred, queryString) => {
    switch (destSrc) {
      case 'login':
        return <SignInComponent viewSiteAs={viewType} queryString={queryString} />;
      case 'signup':
        return (
          <Feature featureName="signup_form_hide_password">
            <Variant id="0">
              <SignUpComponent
                viewSiteAs={viewType}
                updateState={this.updateState}
                userCred={userCred}
                queryString={queryString}
                setSocialAccExists={this.props.setSocialAccExists}
                newDesign={false}
              />
            </Variant>
            <Variant id="1">
              <SignUpComponent
                viewSiteAs={viewType}
                updateState={this.updateState}
                userCred={userCred}
                queryString={queryString}
                setSocialAccExists={this.props.setSocialAccExists}
                newDesign
              />
            </Variant>
          </Feature>
        );
      case 'login/password':
        return (
          <OldPassword
            prevScreen="login"
            viewSiteAs={viewType}
            userCred={userCred}
            queryString={queryString}
          />
        );
      case 'login/otp':
        return (
          <SignInWithOTP
            viewSiteAs={viewType}
            userCred={userCred}
            hideLoader
            queryString={queryString}
          />
        );
      case 'login/password-set':
        return <SetPassword viewSiteAs={viewType} queryString={queryString} />;
      case 'login/social':
        return <SignInSocial viewSiteAs={viewType} queryString={queryString} />;
      case 'signup/social':
        return <SignUpSocial viewSiteAs={viewType} queryString={queryString} />;
      default:
        return <SignInComponent viewSiteAs={viewType} queryString={queryString} />;
    }
  };

  goBack = (destSrc = '', viewType, userCred, queryString) => {
    let { pageType = '', pageName = '' } = pageTypeObject[destSrc];
    if (destSrc === 'login' || destSrc === 'signup') pageName = 'login/signup screen';
    if (destSrc === 'login/otp') pageName = 'login - otp screen';

    gtmEventPush({
      event: 'header_clicks',
      click_text: 'Back',
      page_type: pageType,
      page_name: pageName
    });
    let user = readCookie('uI');
    let { userData = '' } = this.state;
    switch (destSrc) {
      case 'signup':
      case 'login/otp':
      case 'login/social':
      case 'signup/social':
        if (user) {
          eraseCookie('uI');
        }
        return (
          <SignInComponent viewSiteAs={viewType} userData={userData} queryString={queryString} />
        );
        break;
      case 'login/password':
        return (
          <OldPassword
            prevScreen="login"
            viewSiteAs={viewType}
            userCred={userCred}
            queryString={queryString}
          />
        );
        break;
      case 'login/password-set':
        return (
          <SignInWithOTP
            viewSiteAs={viewType}
            userCred={userCred}
            hideLoader
            queryString={queryString}
          />
        );
        break;
    }
  };

  render() {
    let { destSrc = '', viewSiteAs = '', userCred = '' } = this.props;
    viewSiteAs = 'desktop';
    let { location: { search = '', pathname: source = '' } = {} } = this.props;
    let compToRender = this.state.backClicked
      ? this.goBack(destSrc, viewSiteAs, userCred, search)
      : this.componentToRender(destSrc, viewSiteAs, userCred, search);
    return (
      <>
        <Loader name="auth-modal-loader" />
        {this.props.destSrc !== 'login' && !this.state.backClicked && (
          <div
            id="backBtn"
            className="modal-auth-back"
            style={{ width: '100px' }}
            onClick={() => {
              this.setState({
                backClicked: true
              });
              let pageNameBackButton = localStorage.getItem('LoginBackButtonType') || '';
              gtmEventPush({
                page_name: pageNameBackButton,
                page_type: 'user account screen',
                event: 'user_account_interactions',
                category: 'user account interactions',
                action: 'back button'
              });
              localStorage.removeItem('LoginBackButtonType');
            }}
            role="button"
            tabIndex={0}
          >
            {source == '/login' ? null : (
              <span>
                <span className="ic-chevron-left" /> Back{' '}
              </span>
            )}
          </div>
        )}
        {compToRender}
      </>
    );
  }
}

export default withRouter(AuthModalDesktop);
